import React, { Component } from "react";
import PropTypes from "prop-types";
import { reduxForm } from "redux-form";
import { Grid, Button, DialogContentText, Paper, Typography } from "@material-ui/core";
import { setPropsAsInitial } from "../../helpers/setPropsAsInitial";
import { withStyles } from "@material-ui/styles";
import Countdown from "react-countdown-now";

const useStyles = {
  form: { width: "100%", color: "#2E2757", padding: "2% 3% 6% 3%", borderRadius: "12px" },
};

class PropmtForm extends Component {
  constructor(props) {
    super(props);

    const { timeLifeToken, forceReset } = props;
    const now = Date.now();
    let endTime = now + timeLifeToken; // default 5 min

    // Solo usamos localStorage si NO es forceReset
    if (!forceReset) {
      const savedEndTime = localStorage.getItem("otpEndTime");
      if (savedEndTime && parseInt(savedEndTime) > now) {
        endTime = parseInt(savedEndTime);
      }
    }

    this.state = { endTime };
    localStorage.setItem("otpEndTime", endTime);
  }

  handleCancel = (expired = false) => {
    if (expired) localStorage.removeItem("otpEndTime");
    this.props.cancelPrompt();
  };

  renderer = ({ minutes, seconds, completed }) => {
    const mm = minutes < 10 ? "0" + minutes : minutes;
    const ss = seconds < 10 ? "0" + seconds : seconds;
    return <span>{completed ? "00:00" : `${mm}:${ss}`}</span>;
  };

  handleOnKeyPress = (e) => {
    if (this.props.onKeyPress) this.props.onKeyPress(e);
    if (e.target.value.length > 5) e.target.value = "";
  };

  render() {
    const { classes, handleSubmit, length } = this.props;
    const { endTime } = this.state;

    return (
      <Paper elevation={0} className={classes.form}>
        <DialogContentText align="center" color="primary" style={{ fontSize: "0.9rem", fontFamily: "Montserrat, sans-serif" }}>
          Ingrese el código de verificación enviado a su celular.
        </DialogContentText>

        <Typography variant="body2" gutterBottom align="center" style={{ color: "#A0A0A7", fontWeight: "bold" }}>
          <Countdown date={endTime} onComplete={() => this.handleCancel(true)} renderer={this.renderer} />
        </Typography>

        <form onSubmit={handleSubmit}>
          <Grid container spacing={1}>
            <Grid item xs={12} container justifyContent="center">
              <input
                id="otp_number_input"
                onChange={this.handleOnKeyPress}
                maxLength={length || 6}
                type="password"
                style={{ height: "55px", width: "95%", borderRadius: "30px", textAlign: "center", border: "1px solid #D4D3DE", outline: "none" }}
                inputMode="numeric"
              />
            </Grid>
            <Grid item xs={12} container justifyContent="center">
              <Button onClick={() => this.handleCancel(false)} style={{ fontSize: "0.875rem", color: "#FFF", background: "#2E2756", borderRadius: "30px", padding: "6px 18px", width: "60%", marginTop: "10px" }}>
                Cancelar
              </Button>
            </Grid>
          </Grid>
        </form>
      </Paper>
    );
  }
}

PropmtForm.propTypes = {
  label: PropTypes.string.isRequired,
  timeLifeToken: PropTypes.number.isRequired,
  forceReset: PropTypes.bool,
};

const PromptReduxForm = reduxForm({ form: "PropmtForm" })(PropmtForm);

export default setPropsAsInitial(withStyles(useStyles)(PromptReduxForm));
